import React from 'react';
import { InternalFormDecisionRecipients } from '@dill/dill-shared';
import { EmailTagList } from '../InternalForms/ApproveInternalFormModal';

// Same as the backend's fallback when a template hasn't set this (resolveInternalFormDecisionEmails).
export const DEFAULT_INTERNAL_FORM_DECISION_RECIPIENTS: InternalFormDecisionRecipients = {
  includeRequestor: true,
  includeSigners: true,
  includeBranchManagers: false,
  includeRegionalManagers: false,
  includeSalesRep: false,
  emails: [],
};

const OPTIONS: {
  key: Exclude<keyof InternalFormDecisionRecipients, 'emails'>;
  label: string;
}[] = [
  { key: 'includeRequestor', label: 'Requestor (who sent the form)' },
  { key: 'includeSigners', label: 'Everyone who signed' },
  { key: 'includeBranchManagers', label: "Branch Managers of the form's branch" },
  { key: 'includeRegionalManagers', label: "Regional Sales Managers of the branch's region" },
  { key: 'includeSalesRep', label: 'Assigned sales rep' },
];

// INTERNAL_FORM templates only: who the approve / reject dialogs pre-fill as the decision email's
// recipients. The credit team can still add or remove emails in the dialog.
const InternalFormDecisionRecipientsSection = ({
  recipients,
  onChange,
}: {
  recipients: InternalFormDecisionRecipients;
  onChange: (recipients: InternalFormDecisionRecipients) => void;
}) => (
  <div className="border rounded p-2 mt-2 flex flex-col gap-2">
    <span className="text-xs font-semibold">Decision Notification Emails</span>
    <p className="text-xs text-gray-400">
      Pre-filled as the recipients of the approval / rejection email. They can still be changed when
      approving or rejecting.
    </p>
    {OPTIONS.map((option) => (
      <label key={option.key} className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={recipients[option.key]}
          onChange={(e) => onChange({ ...recipients, [option.key]: e.target.checked })}
        />
        <span className="text-xs text-gray-700">{option.label}</span>
      </label>
    ))}
    <EmailTagList
      label="Always include these emails"
      emails={recipients.emails}
      onChange={(emails) => onChange({ ...recipients, emails })}
    />
  </div>
);

export default InternalFormDecisionRecipientsSection;
